import {Component, EventEmitter, Inject, Injector, OnInit} from "@angular/core";
import {MAT_DIALOG_DATA, MatDialogRef} from "@angular/material/dialog";
import {UserService} from "../../dashboard/services/user.service";
import {FormBuilder, FormGroup, Validators} from "@angular/forms";
import {ParameterService} from "../../../_services/parameter.service";
import {MatSnackBar} from "@angular/material/snack-bar";
import {BaseComponentDirective} from "../../../_shared/base/base.component";
import {AdminService} from "../../dashboard/services/admin.service";
import {BehaviorSubject} from "rxjs";
import {AssociationService} from "../../associactions/services/association.service";

@Component({
    selector: 'modal-upload-credit-ceu',
    templateUrl: './upload-ceu-credit.modal.html',
})
export class UploadCeuCreditModal extends BaseComponentDirective implements OnInit {
    public result = new EventEmitter();
    public form: FormGroup;
    public documentTypes: any = {};
    public certifications: any[] = [];

    fileUrl: string | ArrayBuffer;
    fd: FormData;
    uploading = false;

    private myActivities = new BehaviorSubject<any[]>([]);
    activityList: any[] = [];
    activities = this.myActivities.asObservable();
    validationCheck = {
        id: '',
        result: '',
        score: 0
    }

    constructor(
        injector: Injector,
        public dialogRef: MatDialogRef<UploadCeuCreditModal>,
        @Inject(MAT_DIALOG_DATA) public data: any,
        private formBuilder: FormBuilder,
        private userService: UserService,
        private adminService: AdminService,
        private parameterService: ParameterService,
        private associationService: AssociationService,
        private snackbar: MatSnackBar
    ) {
        super(injector);
        this.form = this.formBuilder.group({
            certification: [null, [Validators.required]],
            documentType: [null, [Validators.required]],
            activity: [null, [Validators.required]],
            earnedCredit: [null, [Validators.required]],
        });
    }

    override async ngOnInit(): Promise<void> {
        super.ngOnInit();

        this.form.controls.certification.valueChanges.subscribe(async r => {

            let cert = this.certifications.find(c => c.id == r);
            this.activityList = await this.associationService.getActivitiesByProviderIdNoPaging(cert.association.id);
            this.myActivities.next(this.activityList);

        });

        this.userService.getUserCertificationList().then(async r => {
            this.certifications = r;
            this.documentTypes = await this.parameterService.getParameterByName("DOCUMENT_TYPE");

            if(this.data.mode == 'edit') {
                this.form.controls.certification.setValue(this.data.certificationId);
                this.form.controls.documentType.setValue(this.data.documentType);
                this.form.controls.activity.setValue(this.data.activity);
                this.form.controls.earnedCredit.setValue(this.data.earnedCredit);
            }
        });

    }

    getValidationCheckResult($event: any) {
        this.form.controls.earnedCredit.setValue($event.score);
        this.validationCheck.result = JSON.stringify($event);
    }

    getFileChange($event: FileList): void {
        this.fd = new FormData();
        const fileTransfer = $event[0];
        this.fd.append('file', fileTransfer);
    }

    closeDialog() {
        this.dialogRef.close();
    }

    resetForm() {
        this.form.reset();
        this.form.markAsPristine();
        this.form.markAsUntouched();
    }

    save() {
        this.uploading = true;
        const validation = this.check(this.form);
        this.form.disable();
        if(validation) {
            this.showAlert('Warning', 'Please fill all required input', '');
            this.uploading = false;
            this.form.enable();
            return;
        }

        if(!this.fd) {
            this.showAlert('Warning', 'please add a PDF or image file of your certification', '');
            this.form.enable();
            this.uploading = false;
            return;
        }

        if(this.validationCheck.result == '') {
            this.showAlertDark('Warning', 'please answer all activity conditions', '');
            this.uploading = false;
            this.form.enable();
            return;
        }

        if(this.data.mode == 'edit') {
            this.validationCheck.score = this.form.controls.earnedCredit.value;
            this.userService.updateFile(
                this.fd,
                this.data.documentId,
                this.form.controls.certification.value,
                this.form.controls.documentType.value,
                this.form.controls.activity.value,
                this.validationCheck
            ).then(r => {
                this.snackbar.open('Your CEU document has been added successfully', null, {
                    duration: 3000,
                    verticalPosition: 'bottom',
                    horizontalPosition: 'center'
                });
                this.result.emit(true);
                this.uploading = false;
                this.closeDialog();
            });

        } else {
            this.validationCheck.score = this.form.controls.earnedCredit.value;
            this.userService.uploadFile(
                this.fd,
                this.form.controls.certification.value,
                this.form.controls.documentType.value,
                this.form.controls.activity.value,
                this.validationCheck
            ).then(r => {
                this.snackbar.open('Your CEU document has been added successfully', null, {
                    duration: 3000,
                    verticalPosition: 'bottom',
                    horizontalPosition: 'center'
                });
                    this.result.emit(true);
                    this.uploading = false;
                    this.closeDialog();
            });

        }

    }
}
